<template>
    <div style="min-width: 100px">
        <div class="text-center">
            <p class="mb-0" v-if="!item.isPartial">
                <del
                    >${{
                        item.list_price
                            .toFixed(2)
                            .toString()
                            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                    }}</del
                >
                {{ item.pkgqty > 1 ? 'per unit' : '' }}
            </p>
            <p class="mb-0" v-else><TranslatableStringComponent :tstring="{string: 'configurable'}" /></p>
        </div>
        <div>
            <span v-if="item.sale_price && !item.isPartial" class="dollars"
                >${{
                    item.sale_price
                        .toFixed(2)
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                }}
                {{ item.pkgqty > 1 ? 'per unit' : '' }}</span
            >
            <span v-else-if="item.isPartial"><TranslatableStringComponent :tstring="{string: 'saveUpTo40'}" /></span>
            <span v-else>
                <v-progress-circular
                    :size="14"
                    width="1"
                    color="primary"
                    indeterminate
                ></v-progress-circular>
            </span>
        </div>
    </div>
</template>

<script>
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'ColumnWebPrice',
    components: {
        TranslatableStringComponent,
    },
    data() {
        return {}
    },
    props: {
        item: {
            type: Object,
            default: null,
        },
    },
    methods: {},
    computed: {},
}
</script>

<style></style>
